import { AxiosError, AxiosResponse } from 'axios'

import { IApiResponseVisibilityAppointmentTimeAWS } from '../../../dtos/VisibilityAppointmentTime'
import IVisibilityAppointmentTimeDataSource from '../../dataSource/VisibilityAppointmentTimeDataSource'
import { http } from '../../Http'

export default class VisibilityAppointmentTimeMapper
  implements IVisibilityAppointmentTimeDataSource
{
  async getVisibilityAppointmentTime(): Promise<IApiResponseVisibilityAppointmentTimeAWS> {
    const data: IApiResponseVisibilityAppointmentTimeAWS = await http
      .get<IApiResponseVisibilityAppointmentTimeAWS>(
        `/send_data/visibility_appointment_time`,
      )
      .then((response: AxiosResponse) => {
        const { data } = response
        let dataBody = data.body

        if (typeof data.body === 'string') {
          dataBody = JSON.parse(data.body)
        }
        const dataR: IApiResponseVisibilityAppointmentTimeAWS = {
          statusCode: data.statusCode,
          body: dataBody,
          headers: data.headers,
        }

        return dataR
      })
      .catch((error: AxiosError) => {
        const data: IApiResponseVisibilityAppointmentTimeAWS = {
          statusCode: error.response?.status as number,
          body: error.response?.statusText as string,
          headers: {
            'Access-Control-Allow-Headers': '',
            'Access-Control-Allow-Origin': '',
            'Access-Control-Allow-Methods': '',
          },
        }

        return data
      })

    return data
  }
}
